module.exports = __webpack_public_path__ + "img/icon_solucoesTecnologia5.51cc567a.jpg";